import { Url } from './url';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function callserver(action: string|{url: string}, params: any, callback: JQuery.Ajax.SuccessCallback<any>) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let failCallback: JQuery.Ajax.ErrorCallback<any>;
    let requestUrl: string;

    params.proxy_request_key = window.app.proxy_request_key;

    if (typeof action === 'object') {
        requestUrl = action.url;
    } else {
        requestUrl = Url.getAjaxUrl(`${action}`);
    }

    failCallback = function failCallback(response, errorTextStatus, errorMessage) {
        callback({
            error: {
                message: `${response.status} ${errorMessage}`
            }
        }, null, null);
        console.info(JSON.stringify(response));
        console.info(JSON.stringify(errorTextStatus));
        window.Sentry.captureException(errorMessage);
    };

    $.post(requestUrl, params, callback).fail(failCallback);
}
